import React from 'react';
import { Box, SkeletonGroup, SkeletonRectangle } from '@wix/design-system';
import s from '../common.scss';
const SkeletonCard = () => /*#__PURE__*/React.createElement(Box, {
  direction: "vertical",
  flex: 1,
  minWidth: "0",
  minHeight: "113px",
  borderRadius: "12px",
  border: "1px solid #DEDEDE",
  padding: "12px 24px",
  gap: "SP2",
  align: "space-between"
}, /*#__PURE__*/React.createElement(SkeletonRectangle, {
  className: s.skeleton,
  width: "140px",
  height: "24px"
}), /*#__PURE__*/React.createElement(Box, {
  direction: "horizontal",
  align: "space-between",
  verticalAlign: "middle",
  gap: "SP2",
  width: "100%"
}, /*#__PURE__*/React.createElement(Box, {
  direction: "vertical",
  gap: "SP1"
}, /*#__PURE__*/React.createElement(SkeletonRectangle, {
  className: s.skeleton,
  width: "80px",
  height: "16px"
}), /*#__PURE__*/React.createElement(SkeletonRectangle, {
  className: s.skeleton,
  width: "100px",
  height: "14px"
})), /*#__PURE__*/React.createElement(SkeletonRectangle, {
  className: s.skeletonButton,
  width: "64px",
  height: "32px"
})));
export const TldAlternativesSkeleton = _ref => {
  let {
    limit = 3,
    useMobileLayout = false,
    useFullWidthSkeleton = false
  } = _ref;
  return /*#__PURE__*/React.createElement(SkeletonGroup, {
    skin: "light",
    className: useFullWidthSkeleton ? s.skeletonGroup : undefined
  }, /*#__PURE__*/React.createElement(Box, {
    direction: useMobileLayout ? 'vertical' : 'horizontal',
    gap: useMobileLayout ? 'SP3' : '18px',
    width: "100%",
    flexWrap: useMobileLayout ? 'nowrap' : 'wrap'
  }, Array.from({
    length: limit
  }).map((_, index) => /*#__PURE__*/React.createElement(SkeletonCard, {
    key: index
  }))));
};
//# sourceMappingURL=TldAlternativesSkeleton.js.map